module.exports = __webpack_public_path__ + "fonts/WorkSans-Regular.755318e.ttf";